import React from 'react';
import './index.scss';

const AnalyticsHeaderFitler: React.FC = (props: any) => {
  const onFilterTextBoxChanged = (filter: string) => {
    if (props.api) {
      props.api.setQuickFilter(filter);
    }
  };

  return (
    <div className="ag-header-group-cell-label">
      <div className="analytics-header">
        <input type="text" placeholder={'Filter...'} onInput={e => onFilterTextBoxChanged(e.currentTarget.value)} />
      </div>
    </div>
  );
};

export default AnalyticsHeaderFitler;
